import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Body = styled.div``

const Title = styled.h2`
    margin-bottom: 1em;

    color: ${props => props.theme.colors.lightGreenText};
    text-transform: uppercase;
    font-weight: bold;
    height: 100px !important;
    cursor: pointer;
    text-align: center;
`

const ThankYouPage = styled.div`
    width: 100%;
`

class FormThankYouPage extends React.Component {

    render() {
        const { header, body } = this.props

        return (
            <ThankYouPage>
                <Title>{header}</Title>
                {body && body.thankYouPageBody &&
                    <Body>{body.thankYouPageBody}</Body>
                }
            </ThankYouPage>
        )
    }
}

FormThankYouPage.propTypes = {
    header: PropTypes.string,
    body: PropTypes.object,
    loadingText: PropTypes.string
}

export default FormThankYouPage
